import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  header: {
    fontSize: '32px',
    lineHeight: '36px',
    fontWeight: 700,
    whiteSpace: 'pre-line',
  },
  sidebar: {
    top: theme.spacing(10),
    height: 'fit-content',
  },
  categoryItem: {
    padding: theme.spacing(1.5, 2),
    cursor: 'pointer',
    borderRadius: theme.spacing(1),
    transition: 'all 0.2s ease-in-out',
    marginBottom: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  categoryItemActive: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  categoryTitle: {
    fontSize: '16px',
    fontWeight: 500,
  },
  accordionItem: {
    overflow: 'hidden',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:before': {
      display: 'none',
    },
  },
  accordionSummary: {
    minHeight: '64px !important',
    padding: theme.spacing(0, 3),
  },
  accordionQuestion: {
    fontSize: '20px',
    fontWeight: 500,
    transition: 'color 0.2s ease-in-out',
  },
  accordionDetails: {
    padding: theme.spacing(0, 3, 3, 3),
    fontSize: '18px',
    lineHeight: 1.7,
    color: theme.palette.text.primary,
  },
  expandIcon: {
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    color: theme.palette.grey[500],
  },
}));
